import React, {Fragment, useContext, useEffect, useState} from "react";
import moment from "moment";
import StringToJSX from "../../../../functions/StringToJsx";
import {populateTemplate} from "../../../../functions/PopulateTemplate";
import {isHTML, getTemplate} from "../../../../functions/TemplateHelperFunctions";
import SystemContext from "../../../../SystemContext";
import __ from "lodash";

const prepareLines = (lines) => {

  if (lines && Array.isArray(lines)) {
    lines.forEach(line => {
      line["arrivalDate"] = moment(line.arrivalDate).format("YYYY-MM-DD");
      line["departureDate"] = moment(line.departureDate).format("YYYY-MM-DD");
      line["lineCancelled"] = Boolean(line.lineCancelled);
      line["textDecoration"] = line.lineCancelled ? "line-through" : "";
    })
  }
  //return __.filter(lines, {lineCancelled: false});
  return lines;
}

const FuelOrderView = (props) => {
  const SystemData = useContext(SystemContext);

  const order = props.order;
  const lines = prepareLines(order.lines);

  const [template, setTemplate] = useState(null);

  useEffect(() => {
    const getOrderTemplate = async (order) => {
      if (__.has(order, "orderTemplate") && isHTML(order.orderTemplate)) {
        setTemplate(order.orderTemplate);
        return;
      }

      const orderTemplate = await getTemplate(SystemData, "fuelorders", "Fuel Orders", "order", order.orderTemplate || order.fuelOrderTemplateUuid);
      setTemplate(orderTemplate);
    }

    getOrderTemplate(order);
  }, [order, template]);

  if (!template)
    return null;

  return (
    <Fragment>
      <StringToJSX domString={populateTemplate(template, order, lines)}/>
    </Fragment>
  );
}

export default FuelOrderView;
